import { createGlobalStyle } from 'styled-components';
import { semanticColors, typography } from '../styles/tokens';


const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap');
  
  @layer base {
    :root {
      --font-body: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    }
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${semanticColors.background.primary};
    color: ${semanticColors.text.primary};
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  h1, h2, h3, h4, h5, h6, p, figure, blockquote, dl, dd {
    margin: 0;
  }

  h1 {
    ${typography.heading.h1}
  }

  h2 {
    ${typography.heading.h2}
  }

  h3 {
    ${typography.heading.h3}
  }

  h4 {
    ${typography.heading.h4}
  }

  h5 {
    ${typography.heading.h5}
  }

  h6 {
    ${typography.heading.h6}
  }
  
  .sub_title_1 {
    ${typography.subtitle.subtitle1}
  }

  .sub_title_2 {
    ${typography.subtitle.subtitle2}
  }

  .paragraph_1_default {
    ${typography.paragraph.p1.default}
  }

  .paragraph_1_medium {
    ${typography.paragraph.p1.medium}
  }

  .paragraph_2_default {
    ${typography.paragraph.p2.default}
  }

  .paragraph_2_medium {
    ${typography.paragraph.p2.medium}
  }
  
  .body_regular_16 {
    ${typography.paragraph.p1.default}
  }
  
`;

export default GlobalStyle;
